const featuredMediaMentions = {
  displayField: 'header',
  name: 'Featured Media Mentions',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'mentions',
      name: 'Media Mentions',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 3, max: 6 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'mediaMentions' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'featuredMediaMentions',
    version: 4,
    updatedAt: '2024-01-19T22:19:43.177Z'
  }
};
export default featuredMediaMentions;